// Web Push (VAPID) client for the PWA. Subscribes the browser/PWA to push and
// registers the subscription with the API (tied to the logged-in user).
import apiService from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function isWebPushSupported() {
  return (
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

// 'unsupported' | 'denied' | 'subscribed' | 'default'
export async function getSubscriptionState() {
  if (!isWebPushSupported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return sub ? 'subscribed' : 'default';
}

export async function enableWebPush() {
  if (!isWebPushSupported()) {
    throw new Error('Push obvestila niso podprta v tem brskalniku. Na iPhonu najprej "Dodaj na začetni zaslon".');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Dovoljenje za obvestila je bilo zavrnjeno.');
  }
  const reg = await navigator.serviceWorker.ready;
  const { data } = await apiService.getWebPushPublicKey();
  const publicKey = data && data.publicKey;
  if (!publicKey) {
    throw new Error('Strežnik nima nastavljenih VAPID ključev (web push onemogočen).');
  }
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });
  await apiService.subscribeWebPush(subscription.toJSON());
  return true;
}

export async function disableWebPush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) {
    try { await apiService.unsubscribeWebPush({ endpoint: sub.endpoint }); } catch (_) {}
    await sub.unsubscribe();
  }
}
